module.exports = __webpack_public_path__ + "static/img/alipayIcon.04978f11.png";